export default __webpack_public_path__ + "static/media/content_wimmelbild.d09088a8.csv";